// extracted by mini-css-extract-plugin
module.exports = {"homeIcon":"HomeIcon_homeIcon__anHz1","small":"HomeIcon_small__bXcMs"};